import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import Fade from 'react-reveal/Fade'

import tt from '../../img/Composite/trube.png'

function Physical () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
                        <Trans>{t("CompositeReinforcement.15")}</Trans>
                    </p>
                </div>
                <div className='mt-[30px] xl:mt-[65px] flex flex-col relative'>
                <Fade delay={1300}><img src={tt} alt="" className='xl:absolute xl:py-0 px-[50px] sm:px-[150px] md:px-[250px] xl:px-0 left-1/2 xl:!-translate-x-1/2 top-[120px] object-cover w-full h-full xl:w-auto xl:h-auto'/></Fade>
                    <div className='hidden xl:flex justify-between xl:justify-normal'>
                        <Fade bottom delay={200}><div className='sm:mx-auto flex flex-col items-start mt-[40px]'>
                            <div className='max-w-[334px] ml-[25px] xl:ml-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('CompositeReinforcement.18')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('CompositeReinforcement.19')}</Trans></p>
                            </div>
                            <div className='flex flex-row gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                <div className='h-px w-[155px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                        <Fade bottom delay={400}><div className='sm:mx-auto hidden xl:flex flex-col items-end'>
                            <div className='max-w-[334px] mr-[25px] xl:mr-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('CompositeReinforcement.16')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('CompositeReinforcement.17')}</Trans></p>
                            </div>
                            <div className='flex flex-row-reverse gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                <div className='h-px w-[125px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                    </div>
                    <div className='hidden xl:flex justify-between'>
                        <Fade bottom delay={600}><div className='flex flex-col items-start mt-[80px]'>
                            <div className='max-w-[334px] ml-[25px] xl:ml-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('CompositeReinforcement.22')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('CompositeReinforcement.23')}</Trans></p>
                            </div>
                            <div className='flex flex-row gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                <div className='h-px w-[150px] xl:w-[284px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                        <Fade bottom delay={800}><div className='hidden xl:flex flex-col items-end xl:mt-[40px]'>
                            <div className='max-w-[334px] mr-[25px] xl:mr-[49px]'>
                                <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('CompositeReinforcement.20')}</p>
                                <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('CompositeReinforcement.21')}</Trans></p>
                            </div>
                            <div className='flex flex-row-reverse gap-[8px] md:gap-[24px] items-center'>
                                <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                <div className='h-px w-[140px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                            </div>
                        </div></Fade>
                    </div>
                    <div className='hidden xl:flex justify-between'>
                        <Fade bottom delay={600}>
                            <div className='flex flex-col items-start mt-[20px] ml-[25px] xl:ml-[149px]'>
                                <div className='max-w-[334px] ml-[25px] xl:ml-[49px]'>
                                    <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>2.2%</p>
                                    <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('compositerein.add.14')}</Trans></p>
                                </div>
                                <div className='flex flex-row gap-[8px] md:gap-[24px] items-center'>
                                    <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                    <div className='h-px w-[150px] xl:w-[244px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                                </div>
                            </div>
                        </Fade>
                        <Fade bottom delay={1000}>
                            <div className='hidden xl:flex flex-col items-end sm:mr-[15%]'>
                                <div className='max-w-[334px] mr-[25px] xl:mr-[49px]'>
                                    <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('CompositeReinforcement.24')}</p>
                                    <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('CompositeReinforcement.25')}</Trans></p>
                                </div>
                                <div className='flex flex-row-reverse gap-[8px] md:gap-[24px] items-center'>
                                    <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                                    <div className='h-px w-[135px] xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                                </div>
                            </div>
                        </Fade>
                    </div>                    
                </div>
                <div className='xl:hidden grid grid-cols-2 mt-[30px] gap-x-[20px] gap-y-[10px]'>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('CompositeReinforcement.18')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('CompositeReinforcement.19')}</Trans></p>
                    </div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('CompositeReinforcement.20')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('CompositeReinforcement.21')}</Trans></p>
                    </div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('CompositeReinforcement.22')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('CompositeReinforcement.23')}</Trans></p>
                    </div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('CompositeReinforcement.24')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('CompositeReinforcement.25')}</Trans></p>
                    </div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>{t('CompositeReinforcement.16')}</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('CompositeReinforcement.17')}</Trans></p>
                    </div>
                    <div>
                        <p className='open-sans text-[12px] xl:text-[16px] text-[#F26522]'>2.2%</p>
                        <p className='mt-[12px] open-sans text-[12px] xl:text-[16px] font-[300] text-[#F6F6F6]'><Trans>{t('compositerein.add.14')}</Trans></p>
                    </div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                    <div className='h-px xl:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                </div>
            </div>
        </div>
    );
}

export default Physical;